<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        {{ pageTitle }}
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <hc-ks-upload
              :hcCaseFlightFileType="
                HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.VE_KHACH_SAN
              "
              :id="id"
              ref="hcMaybayUpload"
            ></hc-ks-upload>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item
              class="custom-label__input width25"
              label="Danh sách cán bộ"
            >
            </el-form-item>

            <hc-ks-users-readonly
              v-if="!!hcCaseHotel"
              :hcCaseMasterId="hcCaseHotel.caseMasterId"
            ></hc-ks-users-readonly>
          </el-col>

          <el-col :span="24" v-if="!!hcCaseHotel">
            <el-form-item
              class="custom-label__input width25"
              label="Thông tin lưu trú"
            >
              <div class="flex-row flex__left"></div>
            </el-form-item>

            <hc-ks-places
              ref="hcKsPlacesRef"
              v-if="!!hcCaseHotel"
              :hcCaseMasterId="hcCaseHotel.caseMasterId"
            ></hc-ks-places>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;{{ buttonTitle }}
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
  import h from "../../../services/h";
  import hcCaseHotelService from "../../../services/khachsan/hcCaseHotelService";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
  import HcKsPlaces from "./hc-ks-places";
  import HcKsUpload from "./hc-ks-upload";
  import HcKsUsersReadonly from "./hc-ks-users-readonly";
  import CustomDialog from "../../common/custom-dialog";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import constants from "../../../constants";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";

  export default {
    name: "hc-ks-approve-dialog",
    mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
    props: ["isOpen", "id"],
    components: {
      HcKsPlaces,
      HcKsUpload,
      HcKsUsersReadonly,
      CustomDialog
    },

    data() {
      return {
        rules: {
          note: null,
          flightRouteList: null,
          flightFileList: null
        },
        form: {
          note: null,
          flightRouteList: [],
          flightFileList: []
        },
        hcCaseHotel: null,
        HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE,
        veMayBayValidateFileOptions: null,
        pageTitle: null,
        buttonTitle: null
      };
    },

    computed: {},

    watch: {},

    async created() {
      this.initPageTitle();
      this.initValidationRules();
      this.initMayBayFileValidateFileOptions();
      await this.loadHcCaseHotel();
      this.initFormForEdit();
    },

    methods: {
      initPageTitle() {
        this.pageTitle = "Phê duyệt đặt phòng khách sạn";
        this.buttonTitle = "Phê duyệt";
      },

      initMayBayFileValidateFileOptions() {
        this.veMayBayValidateFileOptions = hanhChinhUtils.initMayBayFileValidateFileOptions(
          constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY
        );
      },

      initFormForEdit() {
        this.form.note = this.hcCaseHotel.note;
      },

      loadHcCaseHotel() {
        return hcCaseHotelService
          .findById(this.id)
          .then(response => (this.hcCaseHotel = response.data));
      },

      initValidationRules() {
        let defaultRequiredConstrains = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "blur"
        };
        this.rules.note = [defaultRequiredConstrains];
      },

      validateUploadFiles() {
        return new Promise(resolve => {
          let files = this.$refs.hcMaybayUpload.getData();
          if (!files || !files.length) {
            this.$message.error(
              errorMessageFilter({errorCode: "hcHotel.ticketFiles.required"})
            );
          } else {
            resolve();
          }
        });
      },

      validateForm() {
        return new Promise(resolve => {
          this.$refs.form.validate(valid => {
            if (!valid) {
              this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
            } else {
              resolve();
            }
          });
        });
      },

      convertToSubmitForm() {

        let hotels = h.collect(this.$refs.hcKsPlacesRef.getData(), place => {
          return {
            locationId: place.location,
            hotelId: place.hotel,
            checkIn: place.checkIn,
            checkOut: place.checkOut,
            countRoom1: place.countRoom1,
            countRoom2: place.countRoom2
          };
        });

        return {
          action: constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.PHE_DUYET,
          caseMasterId: this.hcCaseHotel.caseMasterId,
          note: this.form.note,
          files: this.$refs.hcMaybayUpload.getData(),
          hotels: hotels
        };
      },

      submit() {
        this.validateForm()
          .then(() => this.validateUploadFiles())
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            // console.log(JSON.stringify(submitForm));
            return hcCaseHotelService
              .approve(submitForm)
              .then(response => response.data);
          })
          .then(hcCaseHotel => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "hcHotel.approveSuccess"
              })
            );
            this.$emit("approveSuccess", {result: hcCaseHotel});
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-approve-dialog.vue